import { Injectable } from "@angular/core";
import { ActiveCartFacade } from "@spartacus/cart/base/root";

@Injectable({ providedIn: 'root' })
export class GenCheckoutMonitorService {
  private isWellsFargoCart = false;
  private ongoingAbandonment = false;

  constructor(private activeCartService: ActiveCartFacade) {
    this.activeCartService.getActive().subscribe((cart) => {
      this.isWellsFargoCart = !!cart?.wellsFargoCart;
    });
  }

  setOngoingAbandonment(ongoingAbandonment: boolean): void {
    this.ongoingAbandonment = ongoingAbandonment;
  }

  shouldTrackAbandonment(): boolean {
    return this.isWellsFargoCart && !this.ongoingAbandonment;
  }
}